import { IInfoMessage } from '../contracts';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import './MessageView.scss';

import CloseIcon from '../assets/images/close.svg';

export interface IProps {
	message: IInfoMessage;
}

export const MessageView: React.FC<IProps> = ({ message }) => {
	return (
		<div className='edl-message-view-container'>
			<img className='edl-message-view-icon' src={message.iconUrl} alt="alert" />
			<div className={`edl-message-view-title ${message.titleClassName || ''}`} data-test-id="warning-message">
				{message.title}
			</div>
			<div className='edl-message-view-message'>
				{message.text}
			</div>
			{message.retry &&
				<div onClick={message.retry} className='edl-message-view-button'>
					<FormattedMessage id="app.retry" />
				</div>
			}

			{message.clear &&
				<div onClick={message.clear} className='edl-message-view-close-button'>
					<img src={CloseIcon} alt="close" />
				</div>
			}
		</div>
	);
};
